import React from 'react';
import { TreeTable } from 'primereact/treetable';
import JsonHelper, { CategoryCount, StatisticCount } from '../utils/statisticsUtils';
import { node } from 'prop-types';

/* component to wrapp a TreeTable to add functions for node handling e.g.:
- addNode
- moveNode
- insertNode
- fixKeys
- renameNode
- etc...
Caution: to add backend-functionality to this methods the backend-functionality
need to be passed to the wrapper by the parent component!
 */
export default class TreeTableWrapper extends React.Component {
  constructor(props) {
    super(props);

    this.convertNodesForTree = this.convertNodesForTree.bind(this);
    this.insertNode = this.insertNode.bind(this);
    this.fixKeys = this.fixKeys.bind(this);
    this.findNodeEnvironment = this.findNodeEnvironment.bind(this);
  }

  // method to move a node from a place in the table to a different place in the table
  async moveNode(newNodeEnvironment, node, currentNodeEnvironment) {
    const doBackEndEdit = true;
    const doBackEndDelete = false;
    const success = await this.insertNode(newNodeEnvironment, node, doBackEndEdit);
    if (success) {
      await this.deleteNode(currentNodeEnvironment, doBackEndDelete);
    }
    this.setState({ updateView: true }); // don't delete, needed for state update
  }

  async insertNodeNew(fatherNodeEnvironment, nodeToInsert, doBackEndEdit) {
    const { saveBackEnd, createBackEnd, allNodes, node, selectedTreeNodeKey } = this.props;
    return false;
  }

  // method to insert a new node into the table (below the fatherNodeEnvironment)
  async insertNode(fatherNodeEnvironment, nodeToInsert, doBackEndEdit) {
    const { saveBackEnd, createBackEnd, allNodes } = this.props;
    const fatherNode = fatherNodeEnvironment.nodesArray[fatherNodeEnvironment.position];
    // eslint-disable-next-line no-param-reassign
    nodeToInsert.key = `${fatherNode.key}-${fatherNode.children.length}`;
    // nodeToInsert.key = '0-0-0';
    const arrHierarchy = nodeToInsert.key.split('-');
    const newStatistic = StatisticCount[arrHierarchy[0]];
    const newCategory = CategoryCount[arrHierarchy[1]];
    // await this.pushNode(fatherNode, nodeToInsert);
    let success;
    let isCreate = true;
    if (doBackEndEdit) { // edit existing
      isCreate = false;
      success = await saveBackEnd(nodeToInsert, undefined, newStatistic, newCategory);
    } else { // create new
      success = await createBackEnd(nodeToInsert, undefined, newStatistic, newCategory);
    }
    if (success) {
      // update node with answer and set frontend
      const newNode = nodeToInsert;
      if (isCreate) {
        const newData = success.data.contents['genesis.container.content.GenesisTMContent'].transfermodel.entrys[0];
        newNode.data.id = newData.id;
        newNode.data.statistic = newStatistic;
        newNode.data.category = newCategory;
      }
      await this.pushNode(fatherNode, newNode);
      const childrenOfInsertedNode = fatherNode.children[fatherNode.children.length - 1].children;
      if (childrenOfInsertedNode) {
        this.fixKeys(childrenOfInsertedNode, nodeToInsert.key);
      }
    }
    this.setState({ allNodes }); // don't delete, this triggers a FE update!
    return success;
  }

  async pushNode(fatherNode, nodeToInsert) {
    fatherNode.children.push(nodeToInsert);
  }

  // method to delete a Node
  async deleteNode(currentNodeEnvironment, doBackEndDelete) {
    const { saveBackEnd, allNodes } = this.props;
    const { nodesArray } = currentNodeEnvironment;
    const delNode = nodesArray[currentNodeEnvironment.position];
    let success;
    if (doBackEndDelete) {
      success = await saveBackEnd(delNode, undefined, undefined, undefined, 'delete', currentNodeEnvironment.nodesArray, currentNodeEnvironment);
    }
    if (success || !doBackEndDelete) {
      nodesArray.splice(currentNodeEnvironment.position, 1);
      this.updateKeyOfItemAndChildItems(
        nodesArray,
        currentNodeEnvironment.position,
        currentNodeEnvironment.depth,
      );
    }
    this.setState({ allNodes }); // don't delete, this triggers a FE update!
    return node;
  }

  // method to fix all keys in the tree at once
  fixKeys(array, startKey) {
    array.forEach((it, counter) => {
      const item = it;
      item.key = `${startKey}-${counter}`;
      if (item.children) {
        this.fixKeys(item.children, item.key);
      }
    });
  }

  // method to rename a Node
  async renameNode(currentNodeEnvironment) {
    const { saveBackEnd, newNodeDataName } = this.props;
    console.log('RENAME#3', newNodeDataName);
    const node = currentNodeEnvironment.nodesArray[currentNodeEnvironment.position];
    let oldName = node.data.name+'';
    node.data.name = newNodeDataName;
    const ret = saveBackEnd(node, newNodeDataName, undefined, undefined, undefined, undefined, currentNodeEnvironment, oldName);
    return ret;
  }

  // method to rename a footnote in node
  async footnoteNode(currentNodeEnvironment) {
    const { saveBackEnd, newFootnote } = this.props;
    console.log('RENAME#7', newFootnote);
    const node = currentNodeEnvironment.nodesArray[currentNodeEnvironment.position];
    // node.data.name = newNodeDataName;
    const ret = saveBackEnd(node, newFootnote, undefined, undefined, 'footnote', undefined, currentNodeEnvironment);
    return ret;
  }

  // method to find the node environment in all nodes by the nodeKey
  // eslint-disable-next-line class-methods-use-this
  findNodeEnvironment(allNodes, nodeKey, startPos) {
    let start = 0;
    if (startPos) start = startPos;
    const splitNodeKey = nodeKey.split('-');
    // don't user deep copy here
    let nodesArray = allNodes;
    const depth = splitNodeKey.length;
    // return last layer of nodes:
    for (let i = start; i < depth - 1; i += 1) {
      const output = nodesArray[splitNodeKey[i]].children;
      nodesArray = output;
    }
    const ret = { nodesArray, position: splitNodeKey[splitNodeKey.length - 1], depth };
    return ret;
  }

  updateKeyOfItemAndChildItems(nodesArray, startIndex, keyChangePosition) {
    let node;
    let oldKeySplit;
    const startNumber = Number(startIndex);
    for (let counter = startNumber; counter < nodesArray.length; counter += 1) {
      node = nodesArray[counter];
      oldKeySplit = node.key.split('-'); // 1 - 3
      oldKeySplit[keyChangePosition - 1] -= 1;
      node.key = oldKeySplit.join('-');
      if (node.children) {
        node.children = this.updateKeyOfItemAndChildItems(node.children, 0, keyChangePosition);
      }
    }
    return nodesArray;
  }

  convertNodesForTree(nodes) {
    const { currentNode } = this.props;
    nodes.forEach((nd) => {
      const node = nd;
      node.label = node.data.name;
      node.selectable = !node.selectable;
      if (node.key.startsWith(currentNode.key)) {
        node.selectable = false;
      }

      delete node.data;
      if (node.children) {
        this.convertNodesForTree(node.children);
      }
    });
    return nodes;
  }

  render() {
    const {
      allNodes, children,
    } = this.props;
    return (
      <>
        <TreeTable
          rowReorder
          value={allNodes}
          emptyMessage="noch keine Daten geladen"
          selectionMode="single"
        >
          {children}
        </TreeTable>
      </>
    );
  }
}
